import DOMPurify from "dompurify";
export const defaultSanitizeProps = {
    ALLOWED_TAGS: [
        "h1",
        "h2",
        "h3",
        "h4",
        "h5",
        "h6",
        "p",
        "b",
        "i",
        "small",
        "ul",
        "li",
        "ol",
        "sup",
        "sub",
        "br",
    ],
    ALLOWED_ATTR: ["id", "class"],
};
export const sanitizeContent = (content, sanitizeProps = defaultSanitizeProps) => {
    const sanitizedContent = DOMPurify.sanitize(content, sanitizeProps);
    return sanitizedContent;
};
